export default {
  EVENTS: Object.freeze({
    SESSION_REPORT_CREATED: "session-report-created",
    SESSION_REPORT_FORM_SUBMISSION: "session-report-form-submission",
    EXAM_UPDATED: "exam-updated",
    EXAM_SUBMITTED: "submit-exam"
  })
};
